
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#717b8c","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/user"}},[_c('path',{attrs:{"d":"M17 7a5 5 0 11-5-5 5 5 0 015 5z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M20.59 22c0-3.87-3.85-7-8.59-7s-8.59 3.13-8.59 7","opacity":".4"}})])])
          )
        }
      }
    